// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import ViewsUnauthorizeSvg from '@rsuite/icon-font/lib/application/ViewsUnauthorize';
var ViewsUnauthorize = createSvgIcon({
  as: ViewsUnauthorizeSvg,
  ariaLabel: 'views unauthorize',
  category: 'application',
  displayName: 'ViewsUnauthorize'
});
export default ViewsUnauthorize;